import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import { Button, ModalBody } from "reactstrap";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

const formdatatomap = [
  {
    title: "Choose Hiring Type",
    name: "hiring_type",
    placeholder: "Choose hiring type",
  },
];

const ModelWorkHiringType = ({ formData, setFormData, setModalhiringtype }) => {
  const initialValues = {
    hiring_type: formData?.hiring_type || "1",
  };

  const validationSchema = Yup.object().shape({
    hiring_type: Yup.string().required("Hiring type is required"),
  });

  const handleSubmit = (values) => {
    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));
    setModalhiringtype((state) => !state);
  };

  return (
    <>
      <button
        onClick={() => setModalhiringtype((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Hiring Type</h4>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              {}
              {formdatatomap.map((prop, key) => (
                <div key={key} className="form-group">
                  <h6>{prop.title}</h6>
                  <div className="checkbox-label ">
                    <label className="checkbox-container">
                      <Field
                        type="radio"
                        name={prop.name}
                        value="1"
                        checked={formik.values[prop.name] == 1}
                      />
                      <span className="checkmark">Hourly</span>
                    </label>
                    <label className="checkbox-container">
                      <Field
                        type="radio"
                        name={prop.name}
                        value="3"
                        checked={formik.values[prop.name] == 3}
                      />
                      <span className="checkmark">Weekly</span>
                    </label>
                    <label className="checkbox-container">
                      <Field
                        type="radio"
                        name={prop.name}
                        value="4"
                        checked={formik.values[prop.name] == 4}
                      />
                      <span className="checkmark">Monthly</span>
                    </label>
                    <ErrorMessage
                      name={prop.name}
                      component="div"
                      className="error"
                    />
                  </div>
                </div>
              ))}
              <div className="modal-footer ">
                <button type="submit" className="btn">
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </>
  );
};

export default ModelWorkHiringType;
